/* eslint-disable no-underscore-dangle */

import L from 'leaflet';
import { Meteor } from 'meteor/meteor';
import { isEmpty } from 'lodash';

const SVG_SRC = '/maps-buttons/casa.svg';
const SVG_STYLE = 'width:100%; height:100%;';
const CONTAINER_STYLE = `
  cursor: pointer;
  height: 34px;
  width: 34px;
`;

const { defaultMapCenter } = Meteor.settings.public;

L.Control.HomeButton = L.Control.extend({
  options: {
    position: 'topleft',
    coordinates: null,
    zoom: null
  },

  onAdd(map) {
    // eslint-disable-next-line no-param-reassign
    map.homeButton = this;
    const container = L.DomUtil.create('div');
    const svg = L.DomUtil.create('img');
    const { options } = this;
    this._map = map;
    this.setOptions(options);

    container.title = 'Home';
    container.style.cssText = CONTAINER_STYLE;
    svg.src = SVG_SRC;
    svg.style = SVG_STYLE;

    L.DomEvent.disableClickPropagation(container);

    if (options.zoom !== null && options.coordinates !== null) {
      L.DomEvent.on(container, 'click', this._setView, this);
    }
    container.appendChild(svg);
    return container;
  },
  setOptions(opts) {
    const { options } = this;
    if (opts.coordinates) {
      options.coordinates = opts.coordinates;
    }
    if (opts.zoom) {
      options.zoom = opts.zoom;
    }
  },
  _setView() {
    this._map.setView(this.options.coordinates, this.options.zoom);
  }
});

L.control.homebutton = opts => new L.Control.HomeButton(opts);

/**
 * Adds a return to the original position to the leaflet map after the map is loaded.
 *
 * @param {object} leafletMap - The leaflet map.
 * @param {object} mapLocation - The location of the map/layer.
 */
const customHomeButton = (leafletMap, mapLocation) => {
  let locationToUse = mapLocation;
  if (isEmpty(mapLocation)) {
    locationToUse = defaultMapCenter;
  }
  L.control
    .homebutton({
      coordinates: [locationToUse.geometry.coordinates[1], locationToUse.geometry.coordinates[0]],
      zoom: locationToUse.properties.zoom
    })
    .addTo(leafletMap);
};

export default customHomeButton;
